import { Component, OnInit, Input } from "@angular/core";
import { WizardStep } from "../../../wizard/wizard.component";
import { ReservationWizardService } from "../../../services/wizard/reservation/reservation.wizard.service";
import {
  PracticeDocumentationReservation,
  PracticePriceReservation,
} from "../../../model/practice-price-reservation";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { MatDialog } from "@angular/material";
import { NormativeDialogComponent } from "../../dialogs/normative/normative-dialog.component";
import { Normative } from "../../../model/normative";

@Component({
  selector: "app-reservation-price-component",
  templateUrl: "./reservation-price.component.html",
  styleUrls: ["./reservation-price.component.css"],
})
export class ReservationPriceComponent implements OnInit, WizardStep {
  dateOrder: Date;
  isInit = false;
  loading: boolean;
  displayDocumentationColumns = ["Documentation"];
  documentationsDataSource: PracticeDocumentationReservation[] = [];
  showPrice: boolean;
  displayPricesColumns = ["Name", "Amount"];
  pricesDataSource: PracticePriceReservation[] = [];
  normativeReservation: Normative;
  alertNormative = false;
  existsNormative = false;
  price = 0;
  validityDays = "";
  priceTaxTitle = "(no incluye impuestos)";
  normativeAlerted = false;
  @Input("ocultarDateOrder") ocultarDateOrder: boolean;

  constructor(
    private notificationToastService: NotificationToastService,
    private dialog: MatDialog,
    public reservationWizardService: ReservationWizardService
  ) {
    this.isInit = false;
  }

  get completed(): boolean {
    return (
      this.reservationWizardService &&
      this.reservationWizardService.getAllServiceReservations.length > 0
    );
  }

  private setValidityDays() {
    const serviceReservations =
      this.reservationWizardService.getAllServiceReservations;
    this.validityDays = "";
    let maxValidityDay = 0;
    serviceReservations.forEach((serviceReservation) => {
      let validityDay = 0;
      if (serviceReservation.DateOrder) {
        this.dateOrder = serviceReservation.DateOrder;
        this.onDateChange(serviceReservation.DateOrder);
      }

      let existAuthorization = false;

      if (this.documentationsDataSource) {

        existAuthorization = this.documentationsDataSource.some(
          (doc) => doc.IsAuthorization
        );

      }


      console.log(this.documentationsDataSource);

      if (serviceReservation.Entity.AthorizationValidity && existAuthorization) {
        validityDay = serviceReservation.Entity.AthorizationValidityDay
          ? serviceReservation.Entity.AthorizationValidityDay
          : 0;
      } else {
        validityDay = serviceReservation.Entity.MedicalOrderValidityDay
          ? serviceReservation.Entity.MedicalOrderValidityDay
          : 0;
      }
      maxValidityDay = Math.max(maxValidityDay, validityDay);
    });

    this.validityDays = "(" + maxValidityDay + ")";
  }

  get valid(): boolean {
    return this.completed;
  }

  async activate() {
    try {
      this.loading = true;
      this.price = 0;
      const response =
        await this.reservationWizardService.practicePriceReservation();

      this.documentationsDataSource = [];
      this.pricesDataSource = response.PracticePriceReservations;
      this.normativeReservation = response.NormativeReservation;

      this.alertNormative =
        this.normativeReservation.VisualizeEntityNormative ||
        this.normativeReservation.VisualizePlanNormative ||
        this.normativeReservation.VisualizePracticeNormative;

      if (!this.normativeAlerted && this.alertNormative) {
        this.normativeAlerted = true;
        this.showNormative();
      }

      this.existsNormative =
        this.normativeReservation.EntityNormative.length > 0 ||
        this.normativeReservation.PlanNormative.length > 0 ||
        this.normativeReservation.PracticeNormative.length > 0;

      if (this.pricesDataSource && this.pricesDataSource.length > 0) {
        const documents: string[] = [];
        this.pricesDataSource.forEach((item: PracticePriceReservation) => {
          this.price = this.price + item.Amount;
          this.priceTaxTitle = item.Tax
            ? "(incluye iva " + item.Tax + "%)"
            : "(no incluye impuestos)";
          if (
            item.PracticeDocumentationsReservation &&
            item.PracticeDocumentationsReservation.length > 0
          ) {
            item.PracticeDocumentationsReservation.forEach(
              (itemDoc: PracticeDocumentationReservation) => {
                if (documents.indexOf(itemDoc.Documentation) < 0) {
                  documents.push(itemDoc.Documentation);
                  this.documentationsDataSource.push(itemDoc);
                }
              }
            );
          }
        });
      }

      this.setValidityDays();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reserva");
    } finally {
      this.loading = false;
      this.isInit = true;
    }
  }

  onDateChange(value: Date) {
    const serviceReservations =
      this.reservationWizardService.getAllServiceReservations;
    serviceReservations.forEach((serviceReservation) => {
      serviceReservation.DateOrder = value;
      if (serviceReservation.Entity.AthorizationValidity) {
        serviceReservation.DateAuthorization = value;
      }
    });
  }

  showNormative(): void {
    const dialogRef = this.dialog.open(NormativeDialogComponent, {
      width: "70%",
      data: this.normativeReservation,
    });
  }

  showPriceDetails(): void {
    this.showPrice = !this.showPrice;
  }

  save() {
    if (this.reservationWizardService.hasDate()) {
      const msg = this.reservationWizardService.getValidateDateMessage();
      if (msg) {
        this.notificationToastService.info(msg, "Reserva");
      }
    }
  }

  ngOnInit(): void {
    this.isInit = true;
    this.activate();
  }
}
